import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddDiscountModal from "../../components/modals/AddDiscountModal/AddDiscountModal";
import EditDiscountModal from "../../components/modals/EditDiscountModal/EditDiscountModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import DiscountTable from "../../components/Tables/DiscountTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IDiscount } from "../../types/discount.type";
import { IProduct } from "../../types/product.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterDiscounts } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const DiscountPage: React.FC = () => {
  const [brands, setBrands] = useState<IDiscount[]>([]);
  const [filteredBrands, setFilteredBrands] = useState<IDiscount[]>([]);
  const [editSelectedBrand, setEditSelectedBrand] = useState<IDiscount | null>(
    null
  );
  const [visibleBrands, setVisibleBrands] = useState<IDiscount[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddBrandModal, setIsAddBrandModal] = useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);
  const [products, setProducts] = useState<IProduct[]>([]);

  const getDiscounts = async () => {
    try {
      const results = await authApiService.getAllDiscounts();

      return results;
    } catch (err) {
      console.error(err);
    }
  };

  const getProducts = async () => {
    try {
      const results = await authApiService.getAllProducts();

      return results;
    } catch (err) {
      console.error(err);
    }
  };

  const changeVisibiltyBrands = (brands: IDiscount[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (brands) {
      const changedBrands = brands.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleBrands(changedBrands);
    }
  };

  const getOptionsFilter = () => {
    let filteredBrands = [...brands];
    // setRole(role);

    // if (role.value !== EmployeeType.NONE) {
    //   filteredUsers = filteredUsers.filter((user) => user.role === role.value);
    // }

    return filteredBrands;
  };

  const getFiltredBrands = (brands: IDiscount[]) => {
    const data = getOptionsFilter();
    const filtered = filterDiscounts(data, searchValue);
    setFilteredBrands(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getDiscounts();
    if (resp) {
      setBrands(resp);
      getFiltredBrands(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredBrands.length / usersPerPage));
  }, [filteredBrands]);

  useEffect(() => {
    getFiltredBrands(brands);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, brands]);

  useEffect(() => {
    (async () => {
      const data = await getDiscounts();
      if (data) {
        setBrands(data);
      }

      const prod = await getProducts();
      if (prod) {
        setProducts(prod);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyBrands(filteredBrands);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, brands, totalPages, filteredBrands]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={brands?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddBrandModal(true)}
            addButtonTitle="Додати бренд"
          />
        </div>
      </div>
      <DiscountTable
        discounts={visibleBrands}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedBrand}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {isAddBrandModal && (
        <AddDiscountModal
          onClose={() => setIsAddBrandModal(false)}
          onApply={onClickApplyModal}
          products={products}
        />
      )}

      {editSelectedBrand && (
        <EditDiscountModal
          discount={editSelectedBrand}
          onClose={() => setEditSelectedBrand(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
          products={products}
        />
      )}
    </main>
  );
};

export default DiscountPage;
